<template>
  <div
    class="coupon-banner"
    v-if="coupon"
  >
    <img
      class="coupon-banner__gift"
      src="https://cdn-image.bestdealer.com/app-bestdealer/1688/coupon/gift.png"
    >
    <IntlCurrency
      class="coupon-banner__currency"
      currency="us"
      :size="14"
      color="#052785"
    />
    <span class="coupon-banner__amount">{{ coupon.discountAmount }}</span>
    <span class="coupon-banner__off">Off</span>
    <span class="coupon-banner__divider" />
    <span class="coupon-banner__gradient">Total Items Over US ${{ coupon.minOrderAmount }}</span>
  </div>
</template>

<script setup>
import { useCoupon } from '@/views/Carts/hooks/useCoupon'

const { coupon } = useCoupon()
</script>

<style lang="less" scoped>
.coupon-banner {
  margin-bottom: 12px;
  padding: 12px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  background: url('https://cdn-image.bestdealer.com/app-bestdealer/1688/coupon/gift-bg.png') no-repeat right / contain;
  background-color: #DFE8FB;
  font-family: mon-600;
  font-size: 14px;
  color: #052784;

  &__gift {
    margin-right: 8px;
    width: 28px;
    height: 28px;
  }

  &__amount {
    font-family: mon-700;
    padding-left: 3px;
    padding-right: 2px;
    font-size: 16px;
    color: #F55745;
  }

  &__divider {
    margin: 0 12px;
    height: 24px;
    border-left: 1px dashed #1B3E9C;
  }

  &__gradient {
    background: linear-gradient(90deg, #052784 0%, #733A5F 50%, #E14D39 100%);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
  }
}
</style>
